import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, setAuthToken } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post("/admin/login", { username: u, password: p });
      localStorage.setItem("msis_admin_token", r.data.token);
      setAuthToken(r.data.token);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    }
  };
  return (
    <Layout>
      <section className="container-msis py-20 max-w-md">
        <div className="overline mb-3">Admin Portal</div>
        <h1 className="font-display font-bold text-3xl tracking-tight">Sign in</h1>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div><Label>Username</Label><Input data-testid="admin-username" value={u} onChange={e => setU(e.target.value)} required /></div>
          <div><Label>Password</Label><Input data-testid="admin-password" type="password" value={p} onChange={e => setP(e.target.value)} required /></div>
          <button className="btn-primary w-full" data-testid="admin-login-btn">Sign In</button>
        </form>
      </section>
    </Layout>
  );
}
